import { activeTabUrlSchema } from '../../../../schema';
import { CommonFilterValues, commonFilterSchema, commontUrlSchema } from '../../../common';

export const resourceBlocksFilterSchema = commonFilterSchema;

export const resourceBlocksUrlSchema = commontUrlSchema.merge(activeTabUrlSchema).partial();

export type ResourceBlocksFilterValues = CommonFilterValues;
